<template>
  <div>
    <CCardHeader class="p-1">
      <CRow>
        <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

          <strong>{{ $t('returnProducts') }}</strong>

        </CCol>
        <CCol col="4" style="text-align: end">
          <CButton @click="confirm_dialog()" class="mr-1 ml-1" type="submit" size="sm" color="secondary">
            {{ $t('addRetDoc') }}
          </CButton>
          <CButton v-if="selected_factor_id!=0 && selected_type!=11 && selected_type!=12" class="mr-1 ml-1"
                   @click="confirm_dialog_cancel()"
                   type="submit" size="sm" color="secondary">
            {{ $t('invoiceCancellation') }}
          </CButton>
        </CCol>
      </CRow>
    </CCardHeader>
    <CRow>
      <CCol col="4">
        <CSelect
            :label="$t('documentType')"
            :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

            :value.sync="selected_type"
            :options="type_items"
        />
      </CCol>
      <CCol col="3">

        <treeselect v-if="selected_type!=11 && selected_type!=12"
                    v-model="search_factor_text"
                    @select="select_factor"
                    :async="true"
                    :cacheOptions="false"
                    :load-options="load_factors"
                    :placeholder="$t('searchFactor')"
                    :normalizer="normalizer_factors"
        />
        <treeselect v-if="selected_type==11 || selected_type==12"
                    v-model="selected_person"
                    @select="select_person"
                    :async="true"
                    :cacheOptions="false"
                    :load-options="load_persons"
                    :placeholder="$t('components.searchUser')"
                    :normalizer="normalizer_persons"
        />

      </CCol>


    </CRow>

    <CRow>
      <CCol col="3">
        {{ selected_factor.partyCode }} {{ selected_factor.partyName }}
      </CCol>

      <CCol col="2">
        {{ selected_factor.partyMobile }}
      </CCol>
      <CCol col="2" v-if="selected_factor.createdAt">
        {{ get_date(selected_factor.createdAt) }}
      </CCol>
    </CRow>

    <CDataTableFixed
        v-if="selected_type!=11 && selected_type!=12"
        :items="transfer_product_inventory_items"
        :fields="return_product_inventory_fields"
        striped
        height="400px"

        border
        :items-per-page="200"
        hover
    >


      <template #row="{item,index}">

        <td>
          <p style="text-align: center">
            {{ index + 1 }}
          </p>

        </td>

      </template>

      <template #qty="{item}">
        <td>
          <p style="text-align: right">
            {{ get_currency_no_fix(Math.abs(item.qty)) }}
          </p>
        </td>
      </template>
      <template #returnQty="{item}">
        <td>
          <p style="text-align: right">
            {{ get_currency_no_fix(Math.abs(item.returnQty)) }}
          </p>
        </td>
      </template>
      <template #existance="{item}">
        <td>
          <p style="text-align: right">
            {{ get_currency_no_fix(Math.abs(item.existance)) }}
          </p>
        </td>
      </template>
      <template #retQty="{item,index}">

        <td>
          <p style="text-align: right">
            <CInputCurrency @input="change_ret_qty(index, ...arguments)" :value.sync="item.retQty"/>
          </p>
        </td>
      </template>
      <template #productCode="{item}">
        <td>
          <p style="text-align: center" v-if="item.productCode">
            {{ item.productCode }}
          </p>
        </td>
      </template>
      <template #description="{item}">

        <td>
          <CSelect :value.sync="item.selected_message" :options="refer_messages"/>
        </td>

      </template>
      <template #select-header="{item}">
        <input type="checkbox" v-model="check_all_exit"
        />
      </template>
      <template #select="{item}">
        <td>
          <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                 :value="item.detailId"/>
        </td>
      </template>
    </CDataTableFixed>
    <CDataTableFixed
        v-if="selected_type==11 || selected_type==12"

        :items="product_items"
        :fields="product_fields"
        :items-per-page="200"
        hover
        sorter
        :sticky_zero="true"

        height="250px"
        pagination
    >
      <template #row="{item,index}">

        <td>
          <p v-if="index!=0">{{ item.row_id }}</p>

        </td>

      </template>
      <template #name="{item,index}">

        <td v-if="index==0">

          <treeselect
              :cacheOptions="false"
              v-model="selected_product"
              ref="product_searcher"
              id="product_seeker"
              :async="true"
              v-if="status_product_form==-1"

              :appendToBody="true"
              @select="select_product"
              :load-options="load_products"
              :placeholder="$t('searchItem')"
              :normalizer="normalizer_products"
          />
          <label v-else>{{ product_name }}</label>

        </td>

        <td v-else>
          <p>{{ item.name }}</p>

        </td>

      </template>

      <template #unit="{item}">

        <td>
          <p>{{ item.unit_value_name }}</p>

        </td>

      </template>

      <template #count="{item,index}">

        <td v-if="index==0">
          <CInputCurrency
              :whitout_decimal="true"
              :placeholder="$t('components.productQty')"
              v-on:keydown.enter="another_focus('product_price_input')"
              id="product_qty_input"

              v-model="product_count"
          />
        </td>

        <td v-else>
          <p style="float: right">{{ get_currency_no_fix(item.count) }}</p>

        </td>

      </template>
      <template #price="{item,index}">

        <td v-if="index == 0">
          <CInputCurrency
              :placeholder="$t('components.unitPrice')"
              id="product_price_input"
              v-on:keydown.enter="add_product_to_document_new()"

              v-model="product_price"
          >

          </CInputCurrency>
        </td>
        <td v-else>
          <p style="float: right">
            <!--                                                {{ get_currency(item.price*item.unit_value) }}</p>-->
            {{ get_currency(item.price) }}</p>

        </td>

      </template>
      <template #totalPrice="{item ,index}">

        <td>
          <p style="float: right" v-if="index !=0">
            {{
              get_currency(calculate_total_price(item))
            }}
          </p>

        </td>

      </template>

      <template #totalPayPrice="{item,index}">
        <td>
          <p style="float: right" v-if="index !=0">
            {{
              get_currency(calculate_total_pay_price(item))
            }} </p>
          <p class="text-center pt-1" v-if="index ==0 && selected_product!=null">
            {{ $t('SaleableQty') }}: {{
              get_currency_no_fix(parseInt(product_existance ))
            }}</p>
        </td>

      </template>
      <template #weight="{item,index}">

        <td>
          <p v-if="index !=0">
            {{
              (item.weight * item.count * item.unit_value)
            }}
          </p>

        </td>

      </template>
      <template #summary="{item}">

        <td>
          <p>{{ item.summary }}</p>

        </td>

      </template>


      <template #operation="{item,index}">
        <td>

          <CIcon v-if="index!=0" class="text-primary mr-1"
                 @click.native="edit_item(item.product_id)"
                 name="cil-pencil"/>

          <CIcon v-if="index!=0" class="text-danger mr-1"
                 @click.native="delete_item(item)"
                 name="cil-trash"/>
          <CButton v-if="status_product_form!=-1 && index==0" title="Cancel" outline
                   color="dark">
            <CIcon class="text-white" size="sm" name="cil-x"
                   @click.native="cancel_edit_product()"></CIcon>
          </CButton>

        </td>
      </template>


    </CDataTableFixed>


    <CModal
        :show.sync="change_status_modal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        size="sm"
        :title="$t('components.changeStatus')"
    >

      <CRow>
        <CCol col="12">
          <div>
            <CRow form class="form-group">
              <CCol tag="label" sm="4" class="col-form-label">
                {{ $t('docDate') }}
              </CCol>
              <CCol sm="8">
                <date-picker
                    v-model="return_doc_date"
                    :min="fyear_min_date"
                    :max="fyear_max_date"
                ></date-picker>
              </CCol>
            </CRow>
          </div>
        </CCol>
        <CCol col="12">
          <CSelect
              :label="$t('inventory')"
              :options="place_items"
              :value.sync="selected_place"/>

        </CCol>
      </CRow>
      <template #footer>
        <CButton v-if="selected_type!=11 && selected_type!=12" @click="return_items(0)"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton v-else
                 @click="insert_data_factor()"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
            @click="change_status_modal = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>
    <CModal
        :show.sync="invoice_cancel_modal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        size="sm"
        :title="$t('components.changeStatus')"
    >

      <CRow>
        <CCol col="12">
          <h4>{{ $t('invoiceCancellation') }}</h4>
          <div>
            <CRow form class="form-group">
              <CCol tag="label" sm="4" class="col-form-label">
                {{ $t('docDate') }}
              </CCol>
              <CCol sm="8">
                <date-picker
                    v-model="return_doc_date"

                ></date-picker>
              </CCol>
            </CRow>
          </div>
        </CCol>
        <CCol col="12">
          <CSelect
              :label="$t('inventory')"
              :options="place_items"
              :value.sync="selected_place"/>

        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="return_items(1)"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
            @click="invoice_cancel_modal = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'

var items = [];
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}
export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {
    return {
      selected_person: null,
      selected_product: null,
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      fyear_min_date: localStorage.getItem('fyear_min_date'),
      fyear_max_date: localStorage.getItem('fyear_max_date'),
      place_items: [],
      selected_place: 0,
      change_status_modal: false,
      invoice_cancel_modal: false,
      start_date: '',
      end_date: '',
      return_doc_date: '',
      selected_factor: {},
      search_factor_text: null,
      selected_factors_for_status: [],
      selected_status: 0,
      status_list: [{label: this.$t('select'), value: 0}, {label: this.$t('inDriver'), value: 25}],
      // 23	ارجاع	10
      // 24	کالاها آماده ارسال	10
      // 25	تحویل سفیر	10
      // 26	در دست سفیر	10
      // 27	در مسیر تحویل	10
      // 28	تحویل شد	10
      change_status_summary: '',
      id_checkbox_items: [],
      type_items: [
        {label: this.$t('components.buyRet'), value: 1},
        {label: this.$t('components.sellRet'), value: 3},
        {label: this.$t('buyCurrencyRet'), value: 7},

      ],
      selected_type: 3,
      transfer_product_inventory_items: [],
      return_product_inventory_fields: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:3%'},
        {key: 'productCode', label: this.$t('components.itemCode'), _style: 'width:20%'},

        {key: 'productName', label: this.$t('itemName'), _style: 'width:30%'},

        {key: 'qty', label: this.$t('beforeQty'), _style: 'width:10%'},
        {key: 'returnQty', label: this.$t('returnedQty'), _style: 'width:10%'},
        {key: 'retQty', label: this.$t('tables.qty'), _style: 'width:10%'},
        {key: 'existance', label: this.$t('components.existence'), _style: 'width:10%'},
        {key: 'description', label: this.$t('retDesc'), _style: 'width:20%'},
        {key: 'select', label: this.$t('retDesc'), _style: 'width:5%'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],
      product_items: [{id: "0"}],
      product_fields: [
        {key: 'row', label: "No.", _style: 'width:3%;text-align:center'},
        {key: 'name', label: this.$t('item'), _style: 'width:23%;text-align:center'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'width:10%;text-align:center'},
        {key: 'count', label: this.$t('tables.qty'), _style: 'width:3%;text-align:center'},
        {key: 'price', label: this.$t('components.unitPrice'), _style: 'width:7%;text-align:center'},
        // {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'width:10%;text-align:center'},
        // {key: 'offPrice', label: this.$t('tables.off'), _style: 'width:7%;text-align:center'},
        // {key: 'taxPrice', label: this.$t('tables.tax'), _style: 'width:10%;text-align:center'},
        {key: 'totalPayPrice', label: this.$t('tables.totalAmount'), _style: 'width:10%;text-align:center'},
        // {key: 'summary', _style: 'width:10%;'},
        {key: 'operation', label: '', _style: 'width:5%;text-align:center'},
      ],
      status_form: 0,
      refer_messages: [],
      selected_factor_id: 0,
      check_all_exit: false,
      status_product_form: -1,

      product_name: '',
      product_existance: '',
      product_unit: '',
      product_unit_name: '',
      product_unit_value: '',
      product_count: '',

      normalizer_factors(node) {
        return {
          id: node.recId,
          label: node.masterCode + " " + node.partyName,
        }
      },
      normalizer_products(node) {
        return {
          id: node.id,
          label: node.productCodeName,

        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
        }
      },

    }
  },
  mounted() {
    if(this.get_access("return_no_reference")){
      this.type_items.push( {label: this.$t('buyReturnWithoutResource'), value: 11})
      this.type_items.push( {label: this.$t('saleReturnWithoutResource'), value: 12})
    }
    this.start_date = this.get_day_before_today(600);
    this.end_date = this.get_today();
    this.return_doc_date = this.get_today();

    this.$root.root_validate_errors = [];
    this.get_places()
    this.get_messages();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.return_items(0);

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {


    'selected_type': function () {
      this.search_factor_text = null;
      this.transfer_product_inventory_items = [];
      this.selected_factor = {};
    },
    'check_all_exit': function () {
      if (this.check_all_exit) {
        this.id_checkbox_items = [];

        this.transfer_product_inventory_items.forEach((val) => {
          this.id_checkbox_items.push(val.detailId);
        });
      } else {
        this.id_checkbox_items = [];
      }
    },

  },
  methods: {
    calculate_total_price(item) {
      // console.log('calc total',item);
      return item.price * item.count //* item.unit_value;
    },
    calculate_total_pay_price(item) {

      var off = 0;

      var tax = 0;
      return this.calculate_total_price(item) - off + tax
    },
    add_product_to_document_new() {
      this.$root.root_validate_errors = [];
      if (this.status_product_form != -1) {
        this.update_product_to_document();
        return
      }
      var product_new_item = [];

      product_new_item.unit_value_name = "";
      product_new_item.unit_value = this.product_unit_value;
      product_new_item.name = this.product_name;
      product_new_item.non_off = this.product_non_off;
      product_new_item.unit = this.product_unit;
      product_new_item.count = this.product_count;
      product_new_item.price = this.product_price;
      product_new_item.summary = this.product_summary;
      product_new_item.weight = this.product_weight;
      product_new_item.product_id = this.selected_product;
      product_new_item.product_off = this.product_off;
      product_new_item.product_tax = this.product_tax;
      product_new_item.product_off_is_percent = this.product_off_is_percent;

      product_new_item.totalPrice = this.calculate_total_price(product_new_item);
      product_new_item.offPrice = 0;
      product_new_item.taxPrice = 0;
      product_new_item.totalPayPrice = this.calculate_total_pay_price(product_new_item);

      console.log('product is ', product_new_item)
      this.product_items.push(product_new_item);
      this.product_name = "";
      this.product_non_off = false;
      this.product_unit = "";
      this.product_off = "";
      this.product_tax = "";
      this.product_count = "";
      this.product_summary = '';
      this.product_price = "";
      this.selected_product = null;

      var row_index = 0;
      this.product_items.forEach((val) => {
        val.row_id = row_index;
        row_index += 1;

      });
      if (this.status_form != 0) {
        this.add_one_factor_product(this.product_items.length - 1);
      }


      this.text_input_searcher = document.getElementById("product_seeker").children[0].children[0].children[2].children[0]

      this.text_input_searcher.focus();


    },
    update_product_to_document() {
      if (true) {
        var product_new_item = [];

        product_new_item.unit_value = this.product_unit_value;
        product_new_item.unit_value_name = "";
        // product_new_item.unit_value = 1;

        if (this.status_product_form != -1) {
          // product_new_item.detail_id = this.product_items[this.status_product_form].detail_id;
          product_new_item.detail_id = this.product_items.filter(x => x.product_id == this.status_product_form)[0].detail_id;

        }
        product_new_item.name = this.product_name;
        product_new_item.non_off = this.product_non_off;
        product_new_item.unit = this.product_unit;
        product_new_item.count = this.product_count;
        product_new_item.price = this.product_price;
        product_new_item.summary = this.product_summary;
        product_new_item.weight = this.product_weight;
        product_new_item.product_id = this.selected_product;
        product_new_item.product_off = this.product_off;
        product_new_item.product_tax = this.product_tax;
        product_new_item.product_off_is_percent = this.product_off_is_percent;
        console.log("on edit product", product_new_item)
        this.product_items.forEach((val, index) => {
          if (val.product_id == this.status_product_form) {
            this.product_items.splice(index, 1, product_new_item);
          }
        });
        // this.product_items.splice(this.status_product_form, 1, product_new_item);
        this.product_name = "";
        this.product_non_off = false;
        this.product_unit = "";
        this.product_count = "";
        this.product_summary = '';
        this.product_off = "";
        this.product_tax = "";
        this.product_price = 0;
        this.selected_product = null;
        var row_index = 0;
        this.product_items.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });

          this.status_product_form = -1;

      }
    },

    change_ret_qty(index, txt) {
      var id = this.transfer_product_inventory_items[index].detailId

      if (txt.length > 0) {
        if (!this.id_checkbox_items.includes(id)) {
          this.id_checkbox_items.push(id)
        }
      } else {
        if (this.id_checkbox_items.includes(id)) {
          this.id_checkbox_items.splice(this.id_checkbox_items.indexOf(id), 1)
        }
      }
// console.log("changed qty ret",this.id_checkbox_items,txt.length);
    },
    get_places() {
      var self = this;
      self.place_items = [];
      this.$apis.get_places().then(result =>{
        self.place_items = result
        self.selected_place = self.place_items[0].value;

      })


    },
    select_product(node) {

      console.log("node is", node)
      this.product_name = node.productCodeName;
      this.product_existance = node.packStock;
      this.product_unit = node.productUnitId;
      this.product_unit_name = node.productUnitName;
      this.product_unit_value = node.value;
      this.product_count = 1;
if(this.selected_type==11){
  if(node.lastPurchasePrice!=null && parseFloat(node.lastPurchasePrice)>0){
    this.product_price = node.lastPurchasePrice
  }else{
    this.product_price = node.purchasePrice;
  }

}else{
  this.product_price = node.salePrice;

}
      // this.product_off = 0;


      console.log("price is zero", this.product_price)

      this.product_off = 0;

      setTimeout(function () {
        document.getElementById('product_qty_input').focus()

        document.getElementById('product_qty_input').select();
      }, 150);

    },

    load_factors({action, searchQuery, callback}) {
      var self = this;

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          var self = this;


          const formData = new FormData();

          var url = "GetDocsByParams";
          formData.append("docType", this.selected_type);
          formData.append("PersonId", 0);

          // formData.append("id", 3);
          formData.append("SearchTxt", searchQuery);
          formData.append("FirstDate", self.start_date);
          formData.append("SecondDate", self.end_date);

          axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              options = response.data.data.filter(x => x.statusId == 1);

              callback(null, options);

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
            }

          })
              .catch(function (error) {

                console.log(error);
              });
        })
      }
    },
    load_products({action, searchQuery, callback}) {
      var self = this;

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          const formData = new FormData();

          formData.append('SearchTxt', searchQuery);
          if (this.document_person != null) {
            formData.append('PersonId', this.document_person);
          }

          axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
            options = response.data.data;

            callback(null, options);

            // localStorage.setItem("api_token", response.data.access_token);
            // self.$router.push({ path: 'notes' });
          })
              .catch(function (error) {

                console.log(error);
              });


          //  const options = this.get_keywords(searchQuery);
          // const options = [1, 2, 3, 4, 5].map(i => ({
          //     id: `${searchQuery}-${i}`,
          //     name: `${searchQuery}-${i}`,
          // }))

        })
      }
    },

    select_factor(node) {
      console.log("node ", node)
      this.factor_party_name = node.partyName;
      this.factor_date = this.get_date(node.createdAt)
      this.selected_factor_id = node.recId;
      this.selected_factor = node;
      if (node.statusId == 0) {
        this.$root.modal_component.show_validate_errors([this.$t('documentIsNotFinalize')])
      } else {
        this.get_document_details();

      }
    },
    select_person(node) {
      console.log("node ", node)
      this.factor_party_name = node.partyName;
      this.factor_date = this.get_date(node.createdAt)
      this.selected_factor_id = node.recId;
      this.selected_factor = node;
      if (node.statusId == 0) {
        this.$root.modal_component.show_validate_errors([this.$t('documentIsNotFinalize')])
      } else {
        // this.get_document_details();

      }
    },
    load_persons({action, searchQuery, callback}) {
      var self = this;

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          const formData = new FormData();

          formData.append('SearchTxt', searchQuery);

          axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
            options = response.data.data;

            callback(null, options);

            // localStorage.setItem("api_token", response.data.access_token);
            // self.$router.push({ path: 'notes' });
          })
              .catch(function (error) {

                console.log(error);
              });
        })
      }
    },


    get_document_details() {
      var self = this;

      this.id_checkbox_items = [];
      const formData = new FormData();

      var url = "GetDocItemsByDocIdForRet";

      formData.append("id", this.selected_factor_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.transfer_product_inventory_items = content_data.data;
          self.transfer_product_inventory_items.forEach((val) => {
            val.selected_message = self.refer_messages[1].value;
          });
          self.transfer_product_inventory_items.forEach(function (val, index) {
            self.get_product_data(val, index)
          })
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_product_data(val, index) {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetNewProductById";

      formData.append('id', val.productId);
      axios.post(url, formData, {}).then((res) => {
        var obj = self.transfer_product_inventory_items[index]
        obj.existance = res.data.data.packExistence
        Vue.set(self.transfer_product_inventory_items, index, obj)
        // self.transfer_product_inventory_items[index].existance = res.data.existence
        // console.log("res.data.data.existence", self.transfer_product_inventory_items)

      }).catch(function (error) {
        console.log(error);
      });
    },
    get_messages() {
      var self = this;
      const formData = new FormData();

      var url = "GetFactorReferMessages";

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.refer_messages = self.sort_array([], content_data.data, "id", 'title');


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    check_all() {
      console.log('check all clicked');
    },
    goShowDocument(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.recId});
    },


    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      // if (this.description == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      // }
      return false;
      // e.preventDefault();
    },


    edit_item(index) {

      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      var product_new_item = this.product_items.filter(x => x.product_id == index)[0];
      console.log("item_edit", product_new_item)
      this.product_name = product_new_item.name;
      this.product_non_off = product_new_item.non_off;
      this.product_unit = product_new_item.unit;
      this.product_unit_value = product_new_item.unit_value;
      this.product_count = product_new_item.count;
      this.product_weight = product_new_item.weight;
      this.product_price = parseFloat(product_new_item.price).toFixed(2);
      this.product_summary = product_new_item.summary;
      this.product_off = parseFloat(product_new_item.product_off).toFixed(2);
      this.product_tax = parseFloat(product_new_item.product_tax).toFixed(2);
      this.product_off_is_percent = product_new_item.product_off_is_percent;
      this.selected_product = product_new_item.product_id;
      this.status_product_form = index;
      this.get_product_data()
    },
    cancel_edit_product() {
      this.selected_product = null;
      this.product_count = '';
      this.product_price = '';
      this.product_off = '';
      this.product_tax = '';
      this.status_product_form = -1;
    },

    delete_item(item) {

        this.product_items.forEach((val, index) => {
          if (val.product_id == item.product_id) {

            this.product_items.splice(index, 1);
          }
        });
        // this.product_items.splice(this.status_product_form, 1);
        var row_index = 0;
        this.product_items.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });
        this.product_name = "";
        this.product_unit = "";
        this.product_count = "";
        this.product_summary = '';
        this.product_price = 0;
        this.selected_product = null;

        this.status_product_form = -1;

    },


    confirm_dialog() {
      var self = this

      if (this.selected_type == 11 || this.selected_type == 12) {
        this.change_status_modal = true;
        return false;
      }
      if (this.id_checkbox_items.length == 0) {
        this.$root.modal_component.show_validate_errors([this.$t('selectOneProduct')])
        return false;
      }
      var validate_qty = true;
      var validate_qty_stock = true;
      self.id_checkbox_items.forEach(function (val) {
        var ret_qty = self.transfer_product_inventory_items.filter(x => x.detailId == val)[0].retQty;
        var existence = self.transfer_product_inventory_items.filter(x => x.detailId == val)[0].packStock;
        console.log("return qty = ", ret_qty)
        if (ret_qty == '' || ret_qty == '0' || ret_qty == null) {
          validate_qty = false
        }
        if (self.selected_type == 1) {
          if (ret_qty > existence) {
            validate_qty_stock = false
          }
        }
      })
      if (validate_qty == false) {
        self.$root.modal_component.show_validate_errors([self.$t('insertReturnQty')])
        return false;

      }
      if (validate_qty_stock == false) {
        self.$root.modal_component.show_validate_errors([self.$t('retQtyIsOverThanStock')])
        return false;
      }
      this.selected_place = this.transfer_product_inventory_items.filter(x => x.detailId == this.id_checkbox_items[0])[0].placeId;
      // this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("sureToReturn"), [this.$t("dialogs.ok")], this.confirm_delete_name);
      this.change_status_modal = true;

    },
    confirm_dialog_cancel() {
      // if (this.selected_factor_id == 0) {
      //     this.$root.modal_component.show_validate_errors([this.$t('selectOneProduct')])
      //     return false;
      // }
      this.selected_place = this.transfer_product_inventory_items[0].placeId;
      // this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("sureToReturn"), [this.$t("dialogs.ok")], this.confirm_delete_name);
      this.invoice_cancel_modal = true;

    },
    return_items(is_cancel) {

      let self = this;
      const formData = new FormData()
      let url;
      url = "AddFactorReturn";

      self.change_status_modal = false;
      formData.append('BaseFactorId', this.search_factor_text);
      formData.append('PlaceId', this.selected_place);
      formData.append('DocDate', this.return_doc_date);
      formData.append('DocTypeId', this.selected_type + 1);
      formData.append('InvoiceCancel', is_cancel);
      var details = [];
      var validate = true;
      for (var i = 0; i < this.id_checkbox_items.length; i++) {
        var pro = this.transfer_product_inventory_items.filter(x => x.detailId == this.id_checkbox_items[i])[0];
        if (Math.abs(pro.qty) < Math.abs(pro.returnQty) + Math.abs(pro.retQty)) {
          validate = false;
        }
        details.push({
          DetailId: this.id_checkbox_items[i],
          MasterId: this.search_factor_text,
          ProductId: this.transfer_product_inventory_items.filter(x => x.detailId == this.id_checkbox_items[i])[0].productId,
          Qty: this.transfer_product_inventory_items.filter(x => x.detailId == this.id_checkbox_items[i])[0].retQty,
          RetMessageId: this.transfer_product_inventory_items.filter(x => x.detailId == this.id_checkbox_items[i])[0].selected_message,
        })
      }

      if (validate == false) {
        this.$root.modal_component.show_validate_errors([this.$t('returnHasOver')])

        return;
      }
      formData.append('Details', JSON.stringify(details));

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        bus.$emit('return_doc_added', "");
        self.search_factor_text = null;
        self.transfer_product_inventory_items = [];
        self.selected_factor = {};
        self.invoice_cancel_modal = false;
        self.change_status_modal = false;

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    insert_data_factor() {
      if (!this.validateForm()) {
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      url = "AddFactor";

      // if (this.status_form == 0) {
      // } else {
      //   url = "EditFactorMaster";
      //   formData.append('Id', this.status_form)
      //
      // }


      // PayType
      //
      var json_cost = [];

      formData.append('PayType', 35);
      formData.append('AccountId', 0);
      formData.append('BaseFactorId', 0);
      formData.append('CurrencyId', 0);
      formData.append('PayTypePercent', 0);
      formData.append('CurrencyRate', 1);
      formData.append('DocDate', this.return_doc_date);
      formData.append('PartyId', this.selected_person);
      formData.append('PlaceId', this.selected_place);
      formData.append('DocType', this.selected_type);
      formData.append('DeliveryType', 21);
      formData.append('DocDesc', "");
      formData.append('FactorDiscountType', 2);
      formData.append('FactorDiscount', 0);


      formData.append('DeliveryCostList', JSON.stringify(json_cost));
      axios.post(url, formData, {}).then((res) => {

        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (this.status_form == 0) {

          self.master_id = res.data.data.id;
          self.insert_factor_products();

          // self.product_items.forEach((val) => {
          //     self.insert_factor_products(index);
          //     index+=1;
          //
          // });

        } else {
          self.$router.push({path: "/dashboard/documents/show/" + self.status_form})

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    insert_factor_products() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "AddFactorDetail";

      // if (this.status_form == 0) {
      // } else {
      //   url = "EditFactorDetail";
      //   formData.append('Id', this.status_form)
      //
      // }
      let qty_ratio = 1
      if (self.selected_type == 11) {
        qty_ratio = -1
      }
      var sending_products = [];
      var pr_index = 0;
      self.product_items.forEach((val) => {
        if (pr_index != 0) {
          var pro_obj = {
            MasterId: self.master_id,
            PlaceId: self.selected_place,
            ProductId: val.product_id,
            ProductUnitId: val.unit,
            Qty: val.count * qty_ratio,
            Price: val.price / val.unit_value,
            ProductDesc: "",
            Tax: 0,
            Discount: 0
          };
          sending_products.push(pro_obj);
        }
        pr_index = 1;
      });
      var final_sending = {'details': sending_products};
      formData.append('model', JSON.stringify(final_sending));
      // formData.append('PlaceId', this.selected_place);
      // formData.append('ProductId', this.product_items[index].product_id);
      // formData.append('ProductUnitId', this.product_items[index].unit);
      // formData.append('Qty', this.product_items[index].count * this.selectedTypeQty);
      // formData.append('Price', this.product_items[index].price);
      // formData.append('ProductDesc', this.product_items[index].summary);

      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {


        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (this.status_form == 0) {
          self.date = "";
          self.document_person = null;
          self.document_summary = "";
          // if (index == self.product_items.length - 1) {
          self.product_items = [];


          self.$router.push({path: "/dashboard/documents/show/" + self.master_id})
          // }else {
          // this.$router.push({path:'/dashboard/products/list'})
          // self.insert_factor_products(index+1);

          // }
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
  }
}

</script>
